import { useAuth } from "../../lib/auth";

export function AccessDeniedPage() {
  const { signOut, user } = useAuth();

  return (
    <div className="shell-grid flex min-h-screen items-center justify-center px-6 py-10">
      <div className="glass-panel w-full max-w-xl rounded-[32px] border border-rose-400/20 p-8 text-slate-100">
        <p className="text-xs font-semibold uppercase tracking-[0.32em] text-rose-200">
          Access denied
        </p>
        <h1 className="mt-4 text-3xl font-semibold tracking-tight">
          This account is authenticated but not provisioned for the new web shell.
        </h1>
        <p className="mt-4 text-sm leading-7 text-slate-300">
          {user?.email ?? "This user"} needs an explicit admin, support, provider
          owner, or provider staff role in the new FastAPI/Postgres backend.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <button
            className="rounded-full border border-white/15 px-5 py-3 text-sm font-medium text-white transition hover:border-white/30 hover:bg-white/6"
            onClick={() => void signOut()}
            type="button"
          >
            Sign out
          </button>
          <a
            className="rounded-full bg-rose-400 px-5 py-3 text-sm font-semibold text-slate-950 transition hover:bg-rose-300"
            href="mailto:ops@gaamed.local"
          >
            Request access
          </a>
        </div>
      </div>
    </div>
  );
}
